import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, List, ListItem, Grid, Box, styled } from '@mui/material';

const ExclusiveLeadsCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column', // Adjust to stack content vertically
  width: '100%',
  boxShadow: 3,
  textAlign: 'left',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  alignSelf: 'flex-end', // Align button to the right
  marginTop: theme.spacing(2),
}));

function ExclusiveLeadsComponent() {
  return (
    <ExclusiveLeadsCard>
      <Grid container>
        <Grid item xs={12} md={6}>
          <CardMedia
            component="img"
            image="/assets/leadscreenshot.jpg" // Updated path
            alt="UI Screenshot"
            sx={{ width: '100%', height: 'auto' }}
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
          <CardContent>
            <Typography variant="h2" gutterBottom>
              EXCLUSIVE LEADS
            </Typography>
            <Typography variant="body1" gutterBottom>
              STOP WASTING MONEY ON SUBPAR LEADS
            </Typography>
            <List>
              <ListItem>Real Time, consumer requested, motivated HOT leads.</ListItem>
              <ListItem>Interact with consumer instantly</ListItem>
              <ListItem>Exclusive – Single Entity Authorization</ListItem>
              <ListItem>Reliable and Quality</ListItem>
              <ListItem>Flexible Options – Pay-Per-Lead and Workflow Model</ListItem>
              <ListItem>We Provide, You Close</ListItem>
              {/* ... other list items */}
            </List>
          </CardContent>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}>
    <Box sx={{ textAlign: 'center', maxWidth: '80%', paddingLeft: 4 }}> {/* Adjust maxWidth and paddingLeft as needed */}
      <Typography variant="body2" color="text.secondary">
        "ACCORDING TO AN MIT STUDY, IF YOU CALL A LEAD WITHIN 5 MINUTES, VERSUS 30 MINUTES, YOU'RE 100 TIMES MORE LIKELY TO GET A HOLD OF THEM."
      </Typography>
    </Box>
  </Grid>
  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}>
    <Box sx={{ textAlign: 'center', maxWidth: '80%', paddingLeft: 4 }}> {/* Adjust maxWidth and paddingLeft as needed */}
      <Typography variant="body2" color="text.primary" sx={{ fontWeight: 'bold' }}>
        INSTANTLY ENGAGE LEADS TO IMPROVE CONVERSION RATIO.
      </Typography>
    </Box>
  </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <StyledButton variant="contained">LEARN MORE</StyledButton>
        </Grid>
      </Grid>
    </ExclusiveLeadsCard>
  );
}

export default ExclusiveLeadsComponent;
